/* eslint-disable */
import React, {useContext, useState} from "react";
import {TextSectionsDispatch, TextSectionsListContext} from "../context/TextSectionsListContext";
import ToolbarCustomSelect from "./ToolbarCustomSelect";
import {ConfigContext, ConfigDispatch} from "../context/ConfigContext";
import left from '../images/left.svg'
import center from '../images/center.svg'
import right from '../images/right.svg'
import {validateAllLetters} from "../services/helpers";
import {ModalDispatch} from "../context/ModalContext";

export const ToolbarActions = ({
                                   index,
                                   onDeactivateItem,
                                   onSetFontSize,
                                   fontSize,
                                   onsetLetterSpacing,
                                   letterSpacing
                               }) => {

    const configData = useContext(ConfigContext);
    const configDataDispatch = useContext(ConfigDispatch);
    const textSectionDispatch = useContext(TextSectionsDispatch);
    const textSections = useContext(TextSectionsListContext);
    const modalDispatch = useContext(ModalDispatch);
    const [activateFontSelector, setActivateFontSelector] = useState(false);
    const [activateLetterSpacingSelector, setActivateLetterSpacingSelector] = useState(false);
    const [activateFontSizeSelector, setActivateFontSizeSelector] = useState(false);
    const [activateColorSelector, setActivateColorSelector] = useState(false);
    const [activateTypeSelector, setActivateTypeSelector] = useState(false);
    const [activateGridSelector, setActivateGridSelector] = useState(false);

    const fontFamilyOptions = configData.fontsData.map((font) => {
        //console.log('font', font);
        return {
            value: font.fontFamily,
            label: font.fontFamily
        }
    });
    const selectFont = (e) => {
        const userConfirmed = confirm(
            "Zmiana czcionki spowoduje zresetowanie konfiguratora. Czy jesteś pewien że chcesz to zrobić?"
        );

        if (!userConfirmed) {
            return;
        }
        configDataDispatch({
            'type': 'changeFontFamily',
            'payload': e.target.dataset.value
        })
        textSectionDispatch({
            'type': 'set',
            payload: []
        })
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
    }
    /**
     * Zmiana rozmiaru czcionki w konfiguracji i sekcji tekstu
     * @param e
     * @returns {Promise<void>}
     */
    const selectFontSize = async (e) => {
        //Deaktywujemy wszystkie slelect
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
        //pobieramy wartości
        const value = e.target.dataset.value;
        const oldValue = configData.selectedFontSize;
        await changeFontSizeInConfig(value);
        //Znajdujemy obiekt czcionki w konfiguracji
        const fontSizeObject = configData.fontsData.find(font => font.fontFamily === configData.selectedFont).fonts_conf.find(font => font.font_size.name === value);
        const fontSizeObjectFontSize = fontSizeObject.font_size;
        // Aktualizujemy konfigurację
        let updatedConfig = configData;
        updatedConfig.allowedSpecial = fontSizeObject.allowed_special;
        updatedConfig.allowedBigLetters = fontSizeObject.allowed_big_letters;
        updatedConfig.allowedSmallLetters = fontSizeObject.allowed_small_letters;
        updatedConfig.allowedNumbers = fontSizeObject.allowed_numbers;

        if(textSections.length !== 0) {
            //Pobieramy tekst i sprawdzamy czy dla tego tekstu zmiana czcionki jest dozwolona
            const rawContent = textSections[index].rawContent;
            const checkIfChangeIsAllowed = validateAllLetters(rawContent, updatedConfig);
            //Błąd, wyrzucamy komunikat i przywracamy stary rozmiar czcionki
            if (!checkIfChangeIsAllowed) {
                const errorMessage = `
                Nie można zmienić rozmiaru czcionki na ${value}. <br/>
                Dla tgo rozmiaru czcionki dozwolone są : <br/><strong>${updatedConfig.allowedSmallLetters ? 'małe litery ' : ''} ${updatedConfig.allowedBigLetters ? 'duże litery ' : ''} ${updatedConfig.allowedNumbers ? 'cyfry ' : ''} ${updatedConfig.allowedSpecial ? 'znaki specjalne (+ * , . )' : ''}</strong><br/>
            `;
                await showErrorMessage(errorMessage, 'Błąd zmiany rozmiaru czcionki');
                //Przywracamy do starego rozmiaru czcionki
                await changeFontSizeInConfig(oldValue);
                return;
            }
        }
        // Aktualizujemy rozmiar czcionki w sekcji tekstu
        await changeFontSizeInTextSection(fontSizeObjectFontSize);
    }
    /**
     * Zmiana rozmiaru czcionki w sekcji tekstu
     * @param fontSizeObject
     * @returns {Promise<void>}
     */
    const changeFontSizeInTextSection = async (fontSizeObject) => {
        await textSectionDispatch({
            type: 'updateTextSectionFontSize',
            payload: {
                index,
                fontSizeValue: fontSizeObject.slug,
                fontSizeName: fontSizeObject.name,
            }
        });
    }
    /**
     * Zmiana rozmiaru czcionki - zmiana w konfiguracji
     * @param e
     * @returns {Promise<void>}
     */
    const changeFontSizeInConfig = async (value) => {
        await configDataDispatch({
            type: "changeFontSize",
            payload: value
        });
    }
    const selectType = (e) => {
        //console.log('handleClick', e.target.dataset.value);
        configDataDispatch({
            type: 'changeType',
            payload: e.target.dataset.value
        });
        setActivateTypeSelector(false);
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
    };
    const selectLetterSpacing = (e) => {
        //console.log('handleClick', e.target.dataset.value);
        //onsetLetterSpacing(e.target.dataset.value);
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
        configDataDispatch({
            type: "changeLetterSpacing",
            payload: e.target.dataset.value
        });
        textSectionDispatch({
            type: 'updateTextSectionLetterSpacing',
            payload: {
                index,
                letterSpacing: e.target.dataset.value
            }
        });
    }
    const selectColor = (e) => {
        //console.log('handleClick', e.target.dataset.value);
        configDataDispatch({
            type: 'changeColor',
            payload: e.target.dataset.value
        });
        setActivateColorSelector(false);
    };
    const toggleFontsSizeList = () => {
        setActivateFontSizeSelector(!activateFontSizeSelector);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
    }
    const toggleLetterSpacingList = () => {
        setActivateLetterSpacingSelector(!activateLetterSpacingSelector);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
    }
    const toggleFontsList = () => {
        setActivateFontSelector(!activateFontSelector);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateGridSelector(false);
    }
    const toggleColorList = () => {
        setActivateColorSelector(!activateColorSelector);
        setActivateFontSizeSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
    };
    const toggleTypeList = () => {
        setActivateTypeSelector(!activateTypeSelector);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
    };

    const toggleTypeGrid = () => {
        setActivateGridSelector(!activateGridSelector);
        setActivateTypeSelector(false);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
    };

    function updateTextAlign(align) {
        textSectionDispatch({
            type: 'updateTextSectionTextAlign',
            payload: {
                index,
                textAlign: align
            }
        });
    }

    const showErrorMessage = (content, title = 'Błąd', timeout = 5000) => {
        return new Promise((resolve) => {
            //modalDispatch({type: "hideModal"});
            modalDispatch({
                type: "setModalContent",
                payload: {
                    title: title,
                    content: content,
                }
            });
            modalDispatch({type: "showModal"});
            //Czekamy 5 sekund i zamykamy modal
            setTimeout(() => {
                modalDispatch({type: "hideModal"});
            }, timeout);
            resolve();
        });
    }

    // Opcje dla widoku siatki
    const gridViewOptions = [
        { value: true, label: 'Tak' },
        { value: false, label: 'Nie' }
    ];

    // Obsługa zmiany widoku siatki
    const handleGridViewChange = (e) => {
        const value = e.target.dataset.value === "true";
        configDataDispatch({
            type: 'toggleGridView',
            payload: value
        });
        setActivateGridSelector(false);
    };

    return (
        <div className="editor_top__actions" role="toolbar" aria-label="Akcje edytora">
            <ToolbarCustomSelect
                title={"Wybierz czcionkę"}
                value={configData.selectedFont}
                options={fontFamilyOptions}
                active={activateFontSelector}
                toggleList={toggleFontsList}
                handleClick={selectFont}
                onClose={() => setActivateFontSelector(false)}
                loadFonts={true}
                // disabled={true}
            />
            <div className="text-align--center custom-select">
                <div className="custom-select__label" id="text-align-label">Wyjustowanie</div>
                <div role="group" aria-labelledby="text-align-label" style={{display: 'flex', gap: '10px'}}>
                    <button
                        type="button"
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                        onClick={() => updateTextAlign('left')}
                        aria-label="Wyrównaj do lewej"
                    >
                        <img src={left} alt="Ikona wyrównania do lewej"/>
                    </button>
                    <button
                        type="button"
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                        onClick={() => updateTextAlign('center')}
                        aria-label="Wyśrodkuj"
                    >
                        <img src={center} alt="Ikona wyśrodkowania"/>
                    </button>
                    <button
                        type="button"
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                        onClick={() => updateTextAlign('right')}
                        aria-label="Wyrównaj do prawej"
                    >
                        <img src={right} alt="Ikona wyrównania do prawej"/>
                    </button>
                </div>
                <div></div>
            </div>
            <ToolbarCustomSelect
                title={"Odstęp pomiędzy literami"}
                value={configData.selectedLetterSpacing}
                options={configData.fontsLetterSpacingOptions}
                active={activateLetterSpacingSelector}
                toggleList={toggleLetterSpacingList}
                handleClick={selectLetterSpacing}
                onClose={() => setActivateLetterSpacingSelector(false)}
            />
            <ToolbarCustomSelect
                title={"Wysokość czcionki"}
                value={configData.selectedFontSize}
                options={configData.fontSizeOptions}
                active={activateFontSizeSelector}
                toggleList={toggleFontsSizeList}
                handleClick={selectFontSize}
                onClose={() => setActivateFontSizeSelector(false)}
            />

            <ToolbarCustomSelect
                title={"Kolor"}
                value={configData.selectedColor}
                options={configData.colorOptions}
                active={activateColorSelector}
                toggleList={toggleColorList}
                handleClick={selectColor}
                onClose={() => setActivateColorSelector(false)}
            />

            {
                configData.selectedColorObject.id == 196 ? //tylko dla koloru srebrnego
                    <ToolbarCustomSelect
                        title={"Typ"}
                        value={configData.selectedType}
                        options={configData.typeOptions}
                        active={activateTypeSelector}
                        toggleList={toggleTypeList}
                        handleClick={selectType}
                        onClose={() => setActivateTypeSelector(false)}
                    />
                    : null
            }
            {/* Nowy select: Widok siatki */}
            <ToolbarCustomSelect
                title={"Widok siatki"}
                value={configData.showGrid ? "Tak" : "Nie"}
                options={gridViewOptions}
                active={activateGridSelector}
                toggleList={toggleTypeGrid}
                handleClick={handleGridViewChange}
                onClose={() => setActivateGridSelector(false)}
            />
        </div>
    )
}
